const listPermissionNameComponent = {
  AddPermission: "add-permission",
  AllPermission: "get-all-permission",
  EditPermission: "edit-permission",

  AddRole: "add-role",
  AllRoles: "get-all-roles",
  EditRole: "edit-role",

  AllUser: "view-all-user",
  AllUserDeleted: "view-all-user",
  ShowUserInfo: "view-user",

  AllMobileReplace: "view-user",
  AddMobileReplace: "view-user",

  AllNotificationDashboard: "view-all-user",
  AddNotificationDashboard: "view-all-user",
  EditNotificationDashboard: "view-all-user",

  AllPrivateNotification: "view-all-user",
  AddPrivateNotification: "view-all-user",
  EditPrivateNotification: "view-all-user",

  AllMarketer: "view-all-user",
  AddMarketer: "view-all-user",
  ViewMarketer: "view-all-user",
  EditMarketer: "view-all-user",
  AllMarketerUserEditLog: "view-all-user",
  ViewMarketerUserEditLog: "view-all-user",

  AllNoteCall: "view-all-user",
  AddNoteCall: "view-all-user",
  ViewNoteCall: "view-all-user",
  EditNoteCall: "view-all-user",

  ListUserReport: "view-all-user",

  UserMarketerInfo:
    "show-list-increase-wallet-users-are-registered-for-marketer",
  AddUserByMarketer:
    "show-list-increase-wallet-users-are-registered-for-marketer",
  AllUserRegisteredByMarketer:
    "show-list-increase-wallet-users-are-registered-for-marketer",
  AddMarketerCheckout:
    "show-list-increase-wallet-users-are-registered-for-marketer",
  AllMarketerCheckout:
    "show-list-increase-wallet-users-are-registered-for-marketer",
  ViewAskCheckout:
    "show-list-increase-wallet-users-are-registered-for-marketer",
  ViewAllPayment: "show-list-increase-wallet-users-are-registered-for-marketer",

  AllBanner: "add-advertise",
  AddBanner: "add-advertise",
  EditBanner: "add-advertise",
  AllNative: "add-advertise",
  AddNative: "add-advertise",
  EditNative: "add-advertise",
  AllPush: "add-advertise",
  SelectBannerGenerator: "add-advertise",

  AllCampaigns: "add-campaign",
  AllTypesCampaigns: "add-campaign",
  AllTypesBannerCampaigns: "add-campaign",
  AllTypesNativeCampaigns: "add-campaign",
  AddBannerSimpleCampaign: "add-campaign",
  EditBannerSimpleCampaign: "add-campaign",
  AddNativeSimpleCampaign: "add-campaign",
  EditNativeSimpleCampaign: "add-campaign",
  ViewBannerSimpleCampaign: "add-campaign",
  AddGroupSitePublisherContainerCampaignBanner: "add-campaign",

  ReportCampaign: "see-campaigns-report",

  AllPublisher: "view-publisher",
  ReportPositionsReserver: "view-publisher",
  AddGroupSitePublisherContainer: "view-publisher",
  AddGroupSitePublisherAutomate: "view-publisher",
  EditGroupPublisher: "view-publisher",
  AllPagesSitePublisher: "view-publisher",
  // AllPagesSitePublisherForEdit: "view-publisher",
  AllPositionsPageSitePublisher: "view-publisher",
  AllIndependentPositionsSitePublisher: "view-publisher",
  ReportPosition: "view-publisher",
  CheckPositionsHaveDuplicateCampaign: "view-publisher",
  CheckPositionExist: "view-publisher",
  CheckPositionCampaign: "view-publisher",
  AllPreviewPagesSitePublisher: "view-publisher",
  AllPreviewPositionsPageSitePublisher: "view-publisher",
  AllPreviewIndependentPositionsSitePublisher: "view-publisher",

  AllCategoryTicket: "get-all-category-ticket",
  AddCategoryTicket: "add-category-ticket",
  EditCategoryTicket: "edit-category-ticket",

  AllTickets: "view-all-tickets",
  AnswerTicket: "answer-tickets",
  AddTicket: "add-ticket",
  UserTickets: "view-ticket",
  ViewTickets: "view-ticket",

  AllNotificationTicket: "view-notification-ticket",
  AddNotificationTicket: "add-notification-ticket",

  HelpAll: "view-ticket",
  StepByStepCreateCampaignBanner: "view-ticket",

  ManageSitePublisher: "add-site-publisher",
  AddSitePublisher: "add-site-publisher",
  EditSitePublisher: "edit-site-publisher",
  AllCategorySitePublisherAlternative: "add-site-publisher",
  AddCategorySitePublisherViaCategorySubject: "add-site-publisher",
  AddCategorySitePublisherViaSelectPositions: "add-site-publisher",
  AllPagesSitePublisherAlternative: "add-site-publisher",
  AllPositionsPageSitePublisherAlternative: "add-site-publisher",
  AllIndependentPositionsSitePublisherAlternative: "add-site-publisher",
  TypeCategorySitePublisherAlternative: "add-site-publisher",
  AllBannerCategorySitePublisherAlternative: "add-site-publisher",
  EditBannerCategorySitePublisherAlternative: "add-site-publisher",
  AddCategorySitePublisherAlternativeViaSelectWebSitePublisher:
    "add-site-publisher",

  AllCategoriesSitePublisher: "add-category-site-publisher",
  AddCategorySitePublisher: "add-category-site-publisher",
  EditCategoriesSitePublisher: "edit-category-site-publisher",

  ManageAllCampaigns: "view-all-campaigns-users",
  AllCampaignBannerSimpleManage: "view-all-campaigns-users",
  AllCampaignNativeSimpleManage: "view-all-campaigns-users",
  AllCampaignPushSimpleManage: "view-all-campaigns-users",
  AllCampaignsDeleted: "view-all-campaigns-users",
  ManageViewCampaign: "edit-campaign-user",
  ManageEditNativeCampaign: "edit-campaign-user",

  InfoDeletedBannerCampaign: "view-all-campaigns-users",
  InfoDeletedNativeCampaign: "view-all-campaigns-users",

  AllCampaignAlternative: "view-all-campaigns-users",
  AddCampaignAlternative: "view-all-campaigns-users",
  InfoCampaignAlternative: "view-all-campaigns-users",
  LogsAmountCampaign: "view-all-campaigns-users",

  AllGroupUserSitePublisher: "view-category-user-site-publishers",
  GroupUserSitePublisher: "view-category-user-site-publishers",

  ManageAllBanner: "view-all-banners-users",
  AllBannerDeleted: "view-all-banners-users",
  BannerInfoDeleted: "view-all-banners-users",

  ManageAllNative: "view-all-banners-users",
  AllNativeDeleted: "view-all-banners-users",
  NativeInfoDeleted: "view-all-banners-users",
  ManageEditNative: "confirm-banners-users",

  AllPosition: "add-site-publisher",
  AddPosition: "add-site-publisher",
  EditPosition: "add-site-publisher",
  AddPositionIndependent: "add-site-publisher",
  EditPositionIndependent: "add-site-publisher",
  AllPositionIndependent: "add-site-publisher",
  AddImageToPositionIndependent: "add-site-publisher",
  EditImageToPositionIndependent: "add-site-publisher",
  ReportAllPositionInSitePublisher: "add-site-publisher",

  AddPage: "add-site-publisher",
  AllPage: "add-site-publisher",
  EditPage: "add-site-publisher",

  Report: "finance-advertiser",
  Charge: "finance-advertiser",
  Verify: "finance-advertiser",
  Invoices: "finance-advertiser",
  OfficialInvoice: "finance-advertiser",
  Pledge: "finance-advertiser",
  GetGift: "finance-advertiser",

  ManageAllInvoices: "manage-payments",
  AllTransaction: "manage-payments",
  AddTransaction: "manage-payments",
  ManageOfficialInvoice: "manage-payments",
  ManageAllPledge: "manage-payments",
  LogWallet: "manage-payments",
  AllGift: "manage-payments",
  AddGift: "manage-payments",
  EditGift: "manage-payments",
  AllLogEditGift: "manage-payments",
  ViewLogEditGift: "manage-payments",
  UsersUseThisGifts: "manage-payments",
  ManageMarketerAskCheckout: "manage-payments",
  ManageMarketerViewAskCheckout: "manage-payments",
  ListUsersAreRegisteredByMarketer: "manage-payments",
  AllGiftRegisterUser: "manage-payments",
  AddGiftRegisterUser: "manage-payments",
  EditGiftRegisterUser: "manage-payments",
  ListUsesGiftRegisterUser: "manage-payments",
  AllGiftChargeUser: "manage-payments",
  AddGiftChargeUser: "manage-payments",
  EditGiftChargeUser: "manage-payments",
  ViewGiftChargeUser: "manage-payments",
  RangeValueToGiftChargeUser: "manage-payments",

  AllTypeDiscount: "add-discount",

  AllDiscountCampaignBanner: "add-discount",
  AddDiscountCampaignBanner: "add-discount",
  EditDiscountCampaignBanner: "add-discount",
  ViewDiscountCampaignBanner: "add-discount",
  SelectPositionBanner: "add-discount",
  AddDiscountToPositionBanner: "add-discount",
  EditDiscountToPositionBanner: "add-discount",

  AddUserCustomerCoWorker: "add-campaign-to-customer-coworker",
  AllUserCustomerCoWorker: "add-campaign-to-customer-coworker",
  ShowInfoCustomerCoworker: "add-campaign-to-customer-coworker",

  AllTransaction: "manage-payments",
  AddTransaction: "manage-payments",

  AllTransactionCoworker: "add-campaign-to-customer-coworker",
  AddTransactionCoworker: "add-campaign-to-customer-coworker",
  ListCustomerForPledge: "add-campaign-to-customer-coworker",

  ReportCampaignUser: "show-report-campaigns-users",
  ReportCampaignUserCustomer: "add-campaign-to-customer-coworker",
  InfoUser: "fill-info-user",
  InfoCustomerCoworker: "view-info-user-customer-coworker",
  AllCategoryUserSitePublisherCustomer: "view-info-user-customer-coworker",
  ViewCategoryUserSitePublisherCustomer: "view-info-user-customer-coworker",
  AllCampaignCustomer: "view-info-user-customer-coworker",
  ViewCampaignsCustomerBanner: "view-info-user-customer-coworker",
  AllBannerCustomer: "view-info-user-customer-coworker",
  ViewBannerCustomer: "view-info-user-customer-coworker",

  ListCustomers: "add-campaign-to-customer-coworker",
  AllPublisherCoworker: "add-campaign-to-customer-coworker",
  AllCategoryUserSitePublisher: "add-campaign-to-customer-coworker",
  AddCategoryUserSitePublisherContainer: "add-campaign-to-customer-coworker",
  AllPagesSitePublisherCoworker: "add-campaign-to-customer-coworker",
  AllPositionsPageSitePublisherCoworker: "add-campaign-to-customer-coworker",
  AllIndependentPositionsSitePublisherCoworker:
    "add-campaign-to-customer-coworker",
  EditCategoryUserSitePublisherCoworker: "add-campaign-to-customer-coworker",
  AllCampaignsCoworker: "add-campaign-to-customer-coworker",
  AddCampaignsBannerSimpleCoworker: "add-campaign-to-customer-coworker",
  SelectCustomerForAddCampaign: "add-campaign-to-customer-coworker",
  AllTypesCampaignCoworker: "add-campaign-to-customer-coworker",
  AllTypesBannerCampaignsCoworker: "add-campaign-to-customer-coworker",
  AddGroupSitePublisherContainerCampaignBannerCoworker:
    "add-campaign-to-customer-coworker",
  AddGroupSitePublisherContainerCampaignBannerCoworker:
    "add-campaign-to-customer-coworker",
  ViewCampaignCoworker: "add-campaign-to-customer-coworker",
  AllAdvertiseCoworker: "add-campaign-to-customer-coworker",
  AddAdvertiseCoworker: "add-campaign-to-customer-coworker",
  EditAdvertiseCoworker: "add-campaign-to-customer-coworker",
  SelectCustomerForAddAdvertise: "add-campaign-to-customer-coworker",
  AddGroupSitePublisherAutomateCoworker: "add-campaign-to-customer-coworker",

  AllManageSiteUserAdvertiser: "add-site-publisher",
  InfoSiteUserAdvertiser: "add-site-publisher",

  ManageAllSiteUserPublisher: "add-site-publisher",
  InfoSiteUserPublisher: "add-site-publisher",
};

const listPermissionItemMenu = {
  "all-category-ticket": [
    "get-all-category-ticket",
    "delete-category-ticket",
    "get-category-ticket",
    "edit-category-ticket",
    "add-category-ticket",
  ],
  "all-tickets": ["view-all-tickets", "answer-tickets"],
  "notification-ticket": ["view-notification-ticket"],
};

const listPermissionMenu = {
  USER_MENU: ["view-all-user", "view-user", "	delete-user"],
  USER_CUSTOMER_COWORKER_MENU: ["add-campaign-to-customer-coworker"],
  ROLE_PERMISSION_MENU: [
    "get-role",
    "get-all-roles",
    "add-role",
    "edit-role",
    "delete-role",
    "role-permission",
    "add-permission",
    "get-permission",
    "get-all-permission",
    "edit-permission",
    "delete-permission",
  ],
  CAMPAIGNS: ["add-campaign"],
  CAMPAIGNS_REPORT: ["see-campaigns-report"],
  ADVERTISE: ["add-advertise"],
  PUBLISHERS: ["view-publisher"],
  PUBLISHERS_CUSTOMER: ["add-campaign-to-customer-coworker"],
  FINANCES: ["finance-advertiser"],
  MANGE_TICKET: ["add-category-ticket"],
  MANAGE_CATEGORY_PUBLISHER: [
    "add-site-publisher",
    "delete-site-publisher",
    "edit-site-publisher",
    "add-category-site-publisher",
    "delete-category-site-publisher",
    "edit-category-site-publisher",
    "get-category-site-publisher",
  ],
  MANAGE_CAMPAIGNS: ["view-all-campaigns-users"],
  MANAGE_ADVERTISE: ["view-all-banners-users"],
  MANGE_FINANCES: ["manage-payments"],
  MANGE_DISCOUNT: ["add-discount"],
  TICKET_MENU: ["add-ticket"],
  INFO_USER: ["fill-info-user"],
  INFO_USER_COWORKER_CUSTOMER: ["view-info-user-customer-coworker"],
  ADD_USER_BY_MARKETER: [
    "show-list-increase-wallet-users-are-registered-for-marketer",
  ],
};

const isUserHasPermission = (componentName, permissionsUser) => {
  if (!permissionsUser.includes(listPermissionNameComponent[componentName])) {
    return false;
  }

  return true;
};

const isUserHasPermissionTreeMenu = (permissions, permissionsUser) => {
  return permissions.some((val) => permissionsUser.indexOf(val) !== -1);
};

const isUserHasPermissionItemMenu = (
  permissions,
  permissionsUser,
  tagsItem
) => {
  const permissionItemMenu = listPermissionItemMenu[permissions];

  let resultCompare = permissionItemMenu.some(
    (permission) => permissionsUser.indexOf(permission) === -1
  );

  return !resultCompare ? tagsItem : "";
};

export default {
  isUserHasPermission,
  isUserHasPermissionTreeMenu,
  listPermissionMenu,
  isUserHasPermissionItemMenu,
};
